import Dialog from 'components/overlays/Dialog';
import './_styles.scss';

import { useSelector } from 'react-redux';
import { getTeamDialog } from 'store/slices/settingsPageSlice';

import TeamForm from './TeamForm';
import type { TeamFormData } from './types';

interface TeamDialogProps {
    isLoading: boolean;
    isExecuting: boolean;
    isError: boolean;
    onCancel: () => void;
    onConfirm: (data: TeamFormData) => void;
}

const TeamDialog = ({ onConfirm, isLoading, onCancel, isExecuting }: TeamDialogProps) => {
    const { team, showTeamDialog } = useSelector(getTeamDialog);
    const showCloseButton = true;

    let activeTitle;
    if (team !== undefined && team.id !== undefined) {
        activeTitle = 'Edit team information';
    } else {
        activeTitle = 'Add information about the new team';
    }

    return (
        <Dialog
            key={team?.id ?? 'new-team'}
            showCloseButton={showCloseButton}
            data-testid='create-user-dialog'
            bodyClassName='TeamDialog'
            show={showTeamDialog}
            title={<p className='CreateTeamDialog__title'>{activeTitle}</p>}
            body={
                <div className='UserDialog__bodyContent p-0'>
                    <TeamForm
                        team={team}
                        onSubmit={onConfirm}
                        onCancel={onCancel}
                        isLoading={isLoading}
                        isExecuting={isExecuting}
                    />
                </div>
            }
            onClose={onCancel}
            disableEsc={isLoading}
            size={'fullwidth'}
        />
    );
};

export default TeamDialog;
